export const createLocalId = () => `local:${Date.now()}`;

export const isLocalId = (id) => {
  // console.log('isLocalId =>', id, 'typeof =', typeof id, 'constructor =', id?.constructor?.name);
  // Ce code sert à savoir si l'id est local ou non, mais comme sur MariaDB j'ai un retour en nombre, le code ne fonctionne pas, donc on
  // modifie en rajoutant une condition pour savoir si c'est un string ou non

  return typeof id === 'string' && id.startsWith('local:');
};
